import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getLogInOutLog = () => {
  return httpClient.get(server.LOG_IN_OUT_LOG);
};

export const getLogInOutLogById = (id) => {
  return httpClient.get(server.LOG_IN_OUT_LOG + `/${id}`);
};

export const addLogInOutLog = (data) => {
  return httpClient.post(server.LOG_IN_OUT_LOG, data);
};

export const updateLogInOutLog = (id, data) => {
  return httpClient.put(server.LOG_IN_OUT_LOG + `/${id}`, data);
};

export const deleteLogInOutLog = (id) => {
  return httpClient.delete(server.LOG_IN_OUT_LOG + `/${id}`);
};

export const getLogInOutLogBySearch = (com_id, query) => {
  return httpClient.get(
    server.LOG_IN_OUT_LOG + `/search/data-all/${com_id}`,
    query
  );
};

export const getLogInOutLogBySearchPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  user_id,
  com_id,
  datefrom,
  dateto,
  status
) => {
  return httpClient.get(
    server.LOG_IN_OUT_LOG + `/search/data-all-pagination/${com_id}`,
    {
      params: {
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
        user_id: user_id,
        datefrom: datefrom,
        dateto: dateto,
        status: status,
      },
    }
  );
};
